import { Button, Card, Descriptions, Empty, Space, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import myinvoisConfigService from '../../../services/myinvois/myinvois_config.service';

const GenerateConsolidateConfigDetail = ({ park_id, setIsConfigured = () => {}, }) => {
    const [state, setState] = useState({
        loading : false,
        myinvois_park_config : null,
    });

    const fetchConfigDetail = async () => {
        setState(state => ({...state, loading : true, }));

        const myInvoisConfigParkResponse = await myinvoisConfigService?.fetchMyInvoisConfigPark(park_id);
        const { myinvois_park_config, } = myInvoisConfigParkResponse;

        setState(state => ({...state, loading : false, myinvois_park_config, }));
        setIsConfigured?.(Boolean(myinvois_park_config));
    }

    useEffect(() => {
        fetchConfigDetail();
    }, [park_id])

    return (
        <>
            <Spin spinning={state?.loading}>
                {
                    Boolean(state?.myinvois_park_config) ?
                    (
                        <>
                            <Descriptions
                            bordered
                            column={2}
                            size='small'
                            items={[{
                                key: 'name',
                                label: 'Name',
                                children: state?.myinvois_park_config?.name,
                            },
                            {
                                key: 'tax_identification_number',
                                label: 'Tax Identification Number(TIN)',
                                children: state?.myinvois_park_config?.tax_identification_number,
                            },
                            {
                                key: 'id_type',
                                label: 'ID Type',
                                children: state?.myinvois_park_config?.myinvois_type?.name,
                            },
                            {
                                key: 'identification_number',
                                label: 'Registration / Identification / Passport Number',
                                children: state?.myinvois_park_config?.identification_number,
                            },
                            {
                                key: 'sst_registration_number',
                                label: 'SST Registration Number',
                                children: state?.myinvois_park_config?.sst_registration_number ?? "NA",
                            },
                            {
                                key: 'tourism_tax_registration_number',
                                label: 'Tourism Tax Registration Number',
                                children: state?.myinvois_park_config?.tourism_tax_registration_number ?? "NA",
                            },{
                                key: 'msic_code',
                                label: 'MSIC Code',
                                children: state?.myinvois_park_config?.msic_code,
                            },{
                                key: 'business_activity_description',
                                label: 'Business Activity Description',
                                children: state?.myinvois_park_config?.business_activity_description,
                            },{
                                key: 'address',
                                label: 'Address',
                                span : 2,
                                children : (
                                    <>
                                        <div>
                                            <span>{`${state?.myinvois_park_config?.address_line}, ${state?.myinvois_park_config?.postal_zone}`}</span>
                                        </div>
                                    </>
                                )
                            },{
                                key: 'email',
                                label: 'Email',
                                children: state?.myinvois_park_config?.email,
                            },{
                                key: 'contact',
                                label: 'Contact Number',
                                children: state?.myinvois_park_config?.contact,
                            },]}
                            />
                        </>
                    )
                    :
                    (
                        <>
                            <Empty image={Empty?.PRESENTED_IMAGE_SIMPLE} />
                            <Button>Configure E-Invoice</Button>
                        </>
                    )
                }
                
            </Spin>
        </>
    );
}

export default GenerateConsolidateConfigDetail;